import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { DsButtonVariants, DsChipColorVariant } from '@levelaccess/design-system';

@Component({
  selector: 'app-accordion-filter',
  templateUrl: './accordion-filter.component.html',
  styleUrls: ['./accordion-filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AccordionFilterComponent {
  public filtersCollapsed: boolean;
  public readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  public readonly DsChipColorVariant: typeof DsChipColorVariant = DsChipColorVariant;

  @Output()
  public onClose: EventEmitter<void>;
  @Output()
  public onApply: EventEmitter<void>;
  @Output()
  public onClear: EventEmitter<void>;
  @Input()
  public filtersApplied: boolean;
  @Input()
  public filterLabels: string[];

  constructor() {
    this.onClose = new EventEmitter();
    this.onApply = new EventEmitter();
    this.onClear = new EventEmitter();
    this.filtersCollapsed = true;
    this.filtersApplied = false;
    this.filterLabels = [];
  }

  public clearAllFilters(): void {
    this.onClear.emit();
  }

  public closeFilters(): void {
    this.filtersCollapsed = true;
    this.onClose.emit();
  }

  public applyFilters(): void {
    this.filtersCollapsed = true;
    this.onApply.emit();
  }
}
